import React from 'react'
import '../../App.css'
import Quote from '../Quote';

export default function GetAQuote()
{
    return(
        <>
        <Quote />
        </>
    )  

}